import React, { useContext, useCallback } from 'react';
import styled from 'styled-components';

import IvrTreeContext from 'src/presentation/components/pages/ivr/components/ivrTree/ivrTreeContext';
import {
  ClickableGroup,
  Text,
  TextNodeRect,
} from 'src/presentation/components/pages/ivr/components/ivrTree/ivrTreeLayout';

type TextNodeProps = {
  className?: string;
  fontSize?: number;
  height?: number;
  highlighted?: boolean;
  id: string;
  node?: any;
  nodeIsInvalid?: boolean;
  rx?: number;
  selected?: boolean;
  text: string;
  transform?: string;
  width?: number;
  x?: number;
  y?: number;
};

const TextNode = ({
  className,
  fontSize = 7,
  height = 0,
  highlighted,
  id,
  node,
  nodeIsInvalid = false,
  rx,
  selected,
  text,
  transform,
  width = 0,
  x = 0,
  y = 0,
}: TextNodeProps) => {
  const { nodeClick } = useContext(IvrTreeContext);

  const click = useCallback(
    event => {
      event.stopPropagation();
      nodeClick && nodeClick(node);
    },
    [node, nodeClick]
  );

  return (
    <ClickableGroup onClick={click} transform={transform} data-aid={`ivrTreeNode-${id}-option`} className={className}>
      <TextNodeRect
        x={x}
        y={y}
        width={width}
        height={height}
        selected={selected}
        highlighted={highlighted}
        rx={rx}
        nodeIsInvalid={nodeIsInvalid}
      />
      <StyledText
        // x,y should place the text just in the middle of pill
        x={x + width / 2}
        y={y + height / 2 + fontSize / 3}
        textAnchor="middle"
        text={text}
        fontSize={fontSize}
      />
    </ClickableGroup>
  );
};

export const StyledText = styled(Text)`
  font-size: ${p => p.fontSize}px;
`;

export { TextNode };
